import React from "react";
import ViewFormRadio from "./ViewFormRadio";

const ViewFormRadioGroup = ({
  index: mainIndex,
  title,
  answer,
  setAnswer,
  options,
}) => {
  return (
    <div className="form-group">
      <label>{title}</label>
      {options.map((option, index) => (
        <ViewFormRadio
          key={index}
          value={option}
          answer={answer}
          handleChange={(answer) => setAnswer(mainIndex, answer)}
        />
      ))}
    </div>
  );
};

export default ViewFormRadioGroup;
